import { ChevronRight } from 'lucide-react';
import ModuleTopicsCard from './moduleTopicsCard';

import lockIcon from "../../../img/lock.svg";


const ModuleCard = ({
  module,
  title,
  description,
  videoCount,
  topics,
  isSelected = false,
  setIsSelected
}) => {

  return (
    <div>
        <div className="border border-t-[#CBD5E1] border-b-[#CBD5E1] border-x-0 p-4 w-full space-y-1" onClick={() => setIsSelected(module)}>
            <div className='relative flex items-center justify-between'>
                <div className='space-y-1'>
                  <p className="text-[12px] leading-[14px] sm:text-[14px] sm:leading-4 text-black font-gilroy-medium">{module}</p>
                  <h2 className={`text-[15px] leading-6 sm:text-[20px] sm:leading-7 font-gilroy-semibold ${isSelected && "text-[#4659CA]"} mt-1`}>{title}</h2>
                </div>
                <button
                  className="sm:block hidden"
                  aria-label="Toggle Description"
                >
                  <ChevronRight
                    className={`w-5 h-5`}
                  />
                </button>
                {/* <p className={`text-gray-500 sm:hidden flex items-center gap-1 whitespace-nowrap`}>
                  <img src={lockIcon} alt='Lock' height={20} width={20}/> {videoCount} Videos
                </p> */}
                {
                  isSelected && 
                  <div className='absolute w-[4px] h-[30px] sm:h-[72px] bg-[#4659CA] -left-4'/>
                }
            </div>
    
            <p className={`text-gray-500 text-sm mt-2 sm:block hidden font-gilroy-medium`}>
              {description}
            </p>
        </div>
        {
          isSelected && 
          <div className='sm:w-[554px] w-full sm:hidden block'>
            <ModuleTopicsCard topics={topics} />
          </div>
        }
    </div>
  );
};

export default ModuleCard;
